export var VotingOption;
(function (VotingOption) {
    VotingOption["For"] = "for";
    VotingOption["Against"] = "against";
    VotingOption["Abstain"] = "abstain";
    VotingOption["Withhold"] = "withhold";
    VotingOption["NoAction"] = "no_action";
})(VotingOption || (VotingOption = {}));
